﻿/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class FormDocmentCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: FormDocmentDto_Create | null | undefined): Observable<FormDocmentDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormDocmentCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FormDocmentDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormDocmentDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FormDocmentDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FormDocmentDto_WithRelation.fromJS(resultData200) : new FormDocmentDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormDocmentDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAllSearch(input: FormDocmentDto_LoadAllSearch | null | undefined): Observable<PagedResultDtoOfFormDocmentDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormDocmentCrud/LoadAllSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAllSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAllSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFormDocmentDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFormDocmentDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAllSearch(response: HttpResponseBase): Observable<PagedResultDtoOfFormDocmentDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFormDocmentDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfFormDocmentDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFormDocmentDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    changeOnlineState(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FormDocmentCrud/ChangeOnlineState?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeOnlineState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeOnlineState(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processChangeOnlineState(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @return Success
     */
    getOnlineForm(): Observable<FormDocmentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FormDocmentCrud/getOnlineForm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOnlineForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOnlineForm(<any>response_);
                } catch (e) {
                    return <Observable<FormDocmentDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormDocmentDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetOnlineForm(response: HttpResponseBase): Observable<FormDocmentDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FormDocmentDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormDocmentDto[]>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FormDocmentCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: FormDocmentDto_LoadAll | null | undefined): Observable<PagedResultDtoOfFormDocmentDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormDocmentCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFormDocmentDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFormDocmentDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfFormDocmentDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFormDocmentDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfFormDocmentDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFormDocmentDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<FormDocmentDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormDocmentCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FormDocmentDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormDocmentDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FormDocmentDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FormDocmentDto_WithRelation.fromJS(resultData200) : new FormDocmentDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormDocmentDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfFormDocmentDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormDocmentCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFormDocmentDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFormDocmentDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfFormDocmentDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFormDocmentDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfFormDocmentDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFormDocmentDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: FormDocmentDto_Update | null | undefined): Observable<FormDocmentDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormDocmentCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FormDocmentDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormDocmentDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FormDocmentDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FormDocmentDto_WithRelation.fromJS(resultData200) : new FormDocmentDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormDocmentDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FormDocmentCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FormFormalCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: FormFormalDto_Create | null | undefined): Observable<FormFormalDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormFormalCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FormFormalDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormFormalDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FormFormalDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FormFormalDto_WithRelation.fromJS(resultData200) : new FormFormalDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormFormalDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: FormFormalDto_Update | null | undefined): Observable<FormFormalDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormFormalCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FormFormalDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormFormalDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FormFormalDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FormFormalDto_WithRelation.fromJS(resultData200) : new FormFormalDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormFormalDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FormFormalCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAllSearch(input: FormFormalDto_LoadAllSearch | null | undefined): Observable<PagedResultDtoOfFormFormalDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormFormalCrud/LoadAllSearch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAllSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAllSearch(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFormFormalDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFormFormalDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAllSearch(response: HttpResponseBase): Observable<PagedResultDtoOfFormFormalDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFormFormalDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfFormFormalDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFormFormalDto_WithRelation>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FormFormalCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: FormFormalDto_LoadAll | null | undefined): Observable<PagedResultDtoOfFormFormalDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormFormalCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFormFormalDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFormFormalDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfFormFormalDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFormFormalDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfFormFormalDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFormFormalDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<FormFormalDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormFormalCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FormFormalDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormFormalDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FormFormalDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FormFormalDto_WithRelation.fromJS(resultData200) : new FormFormalDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormFormalDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfFormFormalDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormFormalCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFormFormalDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFormFormalDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfFormFormalDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFormFormalDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfFormFormalDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFormFormalDto_WithRelation>(<any>null);
    }
}

@Injectable()
export class FormGroupCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FormGroupCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: FormGroupDto_LoadAll | null | undefined): Observable<PagedResultDtoOfFormGroupDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormGroupCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFormGroupDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFormGroupDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfFormGroupDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFormGroupDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfFormGroupDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFormGroupDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<FormGroupDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormGroupCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FormGroupDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormGroupDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FormGroupDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FormGroupDto_WithRelation.fromJS(resultData200) : new FormGroupDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormGroupDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfFormGroupDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormGroupCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFormGroupDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFormGroupDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfFormGroupDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFormGroupDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfFormGroupDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFormGroupDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: FormGroupDto_Create | null | undefined): Observable<FormGroupDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormGroupCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FormGroupDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormGroupDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FormGroupDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FormGroupDto_WithRelation.fromJS(resultData200) : new FormGroupDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormGroupDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: FormGroupDto_Update | null | undefined): Observable<FormGroupDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormGroupCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FormGroupDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormGroupDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FormGroupDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FormGroupDto_WithRelation.fromJS(resultData200) : new FormGroupDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormGroupDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FormGroupCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

@Injectable()
export class FormRecordCrudServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllDatasForAdmin(): Observable<RecordDocRecadminDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FormRecordCrud/GetAllDatasForAdmin";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDatasForAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDatasForAdmin(<any>response_);
                } catch (e) {
                    return <Observable<RecordDocRecadminDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordDocRecadminDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllDatasForAdmin(response: HttpResponseBase): Observable<RecordDocRecadminDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RecordDocRecadminDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecordDocRecadminDto[]>(<any>null);
    }

    /**
     * @return Success
     */
    getDatas(): Observable<RecordDocRecDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FormRecordCrud/GetDatas";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDatas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDatas(<any>response_);
                } catch (e) {
                    return <Observable<RecordDocRecDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<RecordDocRecDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetDatas(response: HttpResponseBase): Observable<RecordDocRecDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(RecordDocRecDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RecordDocRecDto[]>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAllSearchByDocument(input: FormRecordDto_LoadAllSearch | null | undefined): Observable<PagedResultDtoOfFormRecordDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormRecordCrud/LoadAllSearchByDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAllSearchByDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAllSearchByDocument(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFormRecordDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFormRecordDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAllSearchByDocument(response: HttpResponseBase): Observable<PagedResultDtoOfFormRecordDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFormRecordDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfFormRecordDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFormRecordDto_WithRelation>(<any>null);
    }

    /**
     * @param docId (optional) 
     * @return Success
     */
    getRecordByDocId(docId: number | null | undefined): Observable<FormRecordDto[]> {
        let url_ = this.baseUrl + "/api/services/app/FormRecordCrud/GetRecordByDocId?";
        if (docId !== undefined)
            url_ += "DocId=" + encodeURIComponent("" + docId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecordByDocId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecordByDocId(<any>response_);
                } catch (e) {
                    return <Observable<FormRecordDto[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormRecordDto[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetRecordByDocId(response: HttpResponseBase): Observable<FormRecordDto[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200 && resultData200.constructor === Array) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200.push(FormRecordDto.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormRecordDto[]>(<any>null);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    deleteByIds(ids: number[] | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FormRecordCrud/DeleteByIds?";
        if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteByIds(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteByIds(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    loadAll(input: FormRecordDto_LoadAll | null | undefined): Observable<PagedResultDtoOfFormRecordDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormRecordCrud/LoadAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoadAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFormRecordDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFormRecordDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processLoadAll(response: HttpResponseBase): Observable<PagedResultDtoOfFormRecordDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFormRecordDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfFormRecordDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFormRecordDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | null | undefined): Observable<FormRecordDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormRecordCrud/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<FormRecordDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormRecordDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FormRecordDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FormRecordDto_WithRelation.fromJS(resultData200) : new FormRecordDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormRecordDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    getAll(input: any | null | undefined): Observable<PagedResultDtoOfFormRecordDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormRecordCrud/GetAll?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<PagedResultDtoOfFormRecordDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<PagedResultDtoOfFormRecordDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfFormRecordDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? PagedResultDtoOfFormRecordDto_WithRelation.fromJS(resultData200) : new PagedResultDtoOfFormRecordDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PagedResultDtoOfFormRecordDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    create(input: FormRecordDto_Create | null | undefined): Observable<FormRecordDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormRecordCrud/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(<any>response_);
                } catch (e) {
                    return <Observable<FormRecordDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormRecordDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<FormRecordDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FormRecordDto_WithRelation.fromJS(resultData200) : new FormRecordDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormRecordDto_WithRelation>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    update(input: FormRecordDto_Update | null | undefined): Observable<FormRecordDto_WithRelation> {
        let url_ = this.baseUrl + "/api/services/app/FormRecordCrud/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(<any>response_);
                } catch (e) {
                    return <Observable<FormRecordDto_WithRelation>><any>_observableThrow(e);
                }
            } else
                return <Observable<FormRecordDto_WithRelation>><any>_observableThrow(response_);
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<FormRecordDto_WithRelation> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 ? FormRecordDto_WithRelation.fromJS(resultData200) : new FormRecordDto_WithRelation();
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FormRecordDto_WithRelation>(<any>null);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | null | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/FormRecordCrud/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(<any>response_);
                } catch (e) {
                    return <Observable<void>><any>_observableThrow(e);
                }
            } else
                return <Observable<void>><any>_observableThrow(response_);
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(<any>null);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(<any>null);
    }
}

export class FormDocmentDto_Create implements IFormDocmentDto_Create {
    id: number | undefined;
    no: string | undefined;
    isOnline: boolean | undefined;
    version: string | undefined;
    sequence: number | undefined;
    formal: FormFormal | undefined;

    constructor(data?: IFormDocmentDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.no = data["no"];
            this.isOnline = data["isOnline"];
            this.version = data["version"];
            this.sequence = data["sequence"];
            this.formal = data["formal"] ? FormFormal.fromJS(data["formal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormDocmentDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new FormDocmentDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["no"] = this.no;
        data["isOnline"] = this.isOnline;
        data["version"] = this.version;
        data["sequence"] = this.sequence;
        data["formal"] = this.formal ? this.formal.toJSON() : <any>undefined;
        return data; 
    }

    clone(): FormDocmentDto_Create {
        const json = this.toJSON();
        let result = new FormDocmentDto_Create();
        result.init(json);
        return result;
    }
}

export interface IFormDocmentDto_Create {
    id: number | undefined;
    no: string | undefined;
    isOnline: boolean | undefined;
    version: string | undefined;
    sequence: number | undefined;
    formal: FormFormal | undefined;
}

export class FormFormal implements IFormFormal {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;
    id: number | undefined;
    no: string | undefined;
    name: string | undefined;
    sequence: number | undefined;
    tenantId: number | undefined;
    fullAudited: FullAudited | undefined;
    frequence: FormFormalFrequence | undefined;
    formGroups: FormGroup[] | undefined;

    constructor(data?: IFormFormal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            this.id = data["id"];
            this.no = data["no"];
            this.name = data["name"];
            this.sequence = data["sequence"];
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAudited.fromJS(data["fullAudited"]) : <any>undefined;
            this.frequence = data["frequence"];
            if (data["formGroups"] && data["formGroups"].constructor === Array) {
                this.formGroups = [] as any;
                for (let item of data["formGroups"])
                    this.formGroups.push(FormGroup.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormFormal {
        data = typeof data === 'object' ? data : {};
        let result = new FormFormal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        data["no"] = this.no;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["frequence"] = this.frequence;
        if (this.formGroups && this.formGroups.constructor === Array) {
            data["formGroups"] = [];
            for (let item of this.formGroups)
                data["formGroups"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FormFormal {
        const json = this.toJSON();
        let result = new FormFormal();
        result.init(json);
        return result;
    }
}

export interface IFormFormal {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;
    id: number | undefined;
    no: string | undefined;
    name: string | undefined;
    sequence: number | undefined;
    tenantId: number | undefined;
    fullAudited: FullAudited | undefined;
    frequence: FormFormalFrequence | undefined;
    formGroups: FormGroup[] | undefined;
}

export class FullAudited implements IFullAudited {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;

    constructor(data?: IFullAudited) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
        }
    }

    static fromJS(data: any): FullAudited {
        data = typeof data === 'object' ? data : {};
        let result = new FullAudited();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data; 
    }

    clone(): FullAudited {
        const json = this.toJSON();
        let result = new FullAudited();
        result.init(json);
        return result;
    }
}

export interface IFullAudited {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;
}

export class FormGroup implements IFormGroup {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;
    formItems: FormItem[] | undefined;
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
    extensionData: string | undefined;
    tenantId: number | undefined;
    fullAudited: FullAudited | undefined;
    formFormalId: number | undefined;
    formFormal: FormFormal | undefined;

    constructor(data?: IFormGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
            if (data["formItems"] && data["formItems"].constructor === Array) {
                this.formItems = [] as any;
                for (let item of data["formItems"])
                    this.formItems.push(FormItem.fromJS(item));
            }
            this.id = data["id"];
            this.name = data["name"];
            this.sequence = data["sequence"];
            this.extensionData = data["extensionData"];
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAudited.fromJS(data["fullAudited"]) : <any>undefined;
            this.formFormalId = data["formFormalId"];
            this.formFormal = data["formFormal"] ? FormFormal.fromJS(data["formFormal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormGroup {
        data = typeof data === 'object' ? data : {};
        let result = new FormGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        if (this.formItems && this.formItems.constructor === Array) {
            data["formItems"] = [];
            for (let item of this.formItems)
                data["formItems"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["extensionData"] = this.extensionData;
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["formFormalId"] = this.formFormalId;
        data["formFormal"] = this.formFormal ? this.formFormal.toJSON() : <any>undefined;
        return data; 
    }

    clone(): FormGroup {
        const json = this.toJSON();
        let result = new FormGroup();
        result.init(json);
        return result;
    }
}

export interface IFormGroup {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;
    formItems: FormItem[] | undefined;
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
    extensionData: string | undefined;
    tenantId: number | undefined;
    fullAudited: FullAudited | undefined;
    formFormalId: number | undefined;
    formFormal: FormFormal | undefined;
}

export class FormItem implements IFormItem {
    question: string | undefined;
    answer: string | undefined;
    sequence: string | undefined;
    type: FormItemType | undefined;
    option: string | undefined;
    isRequired: boolean | undefined;

    constructor(data?: IFormItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.question = data["question"];
            this.answer = data["answer"];
            this.sequence = data["sequence"];
            this.type = data["type"];
            this.option = data["option"];
            this.isRequired = data["isRequired"];
        }
    }

    static fromJS(data: any): FormItem {
        data = typeof data === 'object' ? data : {};
        let result = new FormItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["question"] = this.question;
        data["answer"] = this.answer;
        data["sequence"] = this.sequence;
        data["type"] = this.type;
        data["option"] = this.option;
        data["isRequired"] = this.isRequired;
        return data; 
    }

    clone(): FormItem {
        const json = this.toJSON();
        let result = new FormItem();
        result.init(json);
        return result;
    }
}

export interface IFormItem {
    question: string | undefined;
    answer: string | undefined;
    sequence: string | undefined;
    type: FormItemType | undefined;
    option: string | undefined;
    isRequired: boolean | undefined;
}

export class FormDocmentDto_WithRelation implements IFormDocmentDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    no: string | undefined;
    isOnline: boolean | undefined;
    version: string | undefined;
    sequence: number | undefined;
    formal: FormFormal | undefined;

    constructor(data?: IFormDocmentDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.no = data["no"];
            this.isOnline = data["isOnline"];
            this.version = data["version"];
            this.sequence = data["sequence"];
            this.formal = data["formal"] ? FormFormal.fromJS(data["formal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormDocmentDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new FormDocmentDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["no"] = this.no;
        data["isOnline"] = this.isOnline;
        data["version"] = this.version;
        data["sequence"] = this.sequence;
        data["formal"] = this.formal ? this.formal.toJSON() : <any>undefined;
        return data; 
    }

    clone(): FormDocmentDto_WithRelation {
        const json = this.toJSON();
        let result = new FormDocmentDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IFormDocmentDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    no: string | undefined;
    isOnline: boolean | undefined;
    version: string | undefined;
    sequence: number | undefined;
    formal: FormFormal | undefined;
}

export class FullAuditedDto implements IFullAuditedDto {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;

    constructor(data?: IFullAuditedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.creatorUserId = data["creatorUserId"];
            this.creationTime = data["creationTime"] ? new Date(data["creationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.lastModificationTime = data["lastModificationTime"] ? new Date(data["lastModificationTime"].toString()) : <any>undefined;
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? new Date(data["deletionTime"].toString()) : <any>undefined;
            this.isDeleted = data["isDeleted"];
        }
    }

    static fromJS(data: any): FullAuditedDto {
        data = typeof data === 'object' ? data : {};
        let result = new FullAuditedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : <any>undefined;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        return data; 
    }

    clone(): FullAuditedDto {
        const json = this.toJSON();
        let result = new FullAuditedDto();
        result.init(json);
        return result;
    }
}

export interface IFullAuditedDto {
    creatorUserId: number | undefined;
    creationTime: Date | undefined;
    lastModifierUserId: number | undefined;
    lastModificationTime: Date | undefined;
    deleterUserId: number | undefined;
    deletionTime: Date | undefined;
    isDeleted: boolean | undefined;
}

export class FormDocmentDto_LoadAllSearch implements IFormDocmentDto_LoadAllSearch {
    frequence: FormDocmentDto_LoadAllSearchFrequence | undefined;
    isOnline: boolean | undefined;
    keyword: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IFormDocmentDto_LoadAllSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.frequence = data["frequence"];
            this.isOnline = data["isOnline"];
            this.keyword = data["keyword"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): FormDocmentDto_LoadAllSearch {
        data = typeof data === 'object' ? data : {};
        let result = new FormDocmentDto_LoadAllSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frequence"] = this.frequence;
        data["isOnline"] = this.isOnline;
        data["keyword"] = this.keyword;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): FormDocmentDto_LoadAllSearch {
        const json = this.toJSON();
        let result = new FormDocmentDto_LoadAllSearch();
        result.init(json);
        return result;
    }
}

export interface IFormDocmentDto_LoadAllSearch {
    frequence: FormDocmentDto_LoadAllSearchFrequence | undefined;
    isOnline: boolean | undefined;
    keyword: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfFormDocmentDto_WithRelation implements IPagedResultDtoOfFormDocmentDto_WithRelation {
    totalCount: number | undefined;
    items: FormDocmentDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfFormDocmentDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(FormDocmentDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFormDocmentDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFormDocmentDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfFormDocmentDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfFormDocmentDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfFormDocmentDto_WithRelation {
    totalCount: number | undefined;
    items: FormDocmentDto_WithRelation[] | undefined;
}

export class FormDocmentDto implements IFormDocmentDto {
    id: number | undefined;
    no: string | undefined;
    isOnline: boolean | undefined;
    version: string | undefined;
    sequence: number | undefined;
    formal: FormFormal | undefined;

    constructor(data?: IFormDocmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.no = data["no"];
            this.isOnline = data["isOnline"];
            this.version = data["version"];
            this.sequence = data["sequence"];
            this.formal = data["formal"] ? FormFormal.fromJS(data["formal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormDocmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormDocmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["no"] = this.no;
        data["isOnline"] = this.isOnline;
        data["version"] = this.version;
        data["sequence"] = this.sequence;
        data["formal"] = this.formal ? this.formal.toJSON() : <any>undefined;
        return data; 
    }

    clone(): FormDocmentDto {
        const json = this.toJSON();
        let result = new FormDocmentDto();
        result.init(json);
        return result;
    }
}

export interface IFormDocmentDto {
    id: number | undefined;
    no: string | undefined;
    isOnline: boolean | undefined;
    version: string | undefined;
    sequence: number | undefined;
    formal: FormFormal | undefined;
}

export class FormDocmentDto_LoadAll implements IFormDocmentDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IFormDocmentDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): FormDocmentDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new FormDocmentDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): FormDocmentDto_LoadAll {
        const json = this.toJSON();
        let result = new FormDocmentDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IFormDocmentDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class FormDocmentDto_Update implements IFormDocmentDto_Update {
    id: number | undefined;
    no: string | undefined;
    isOnline: boolean | undefined;
    version: string | undefined;
    sequence: number | undefined;
    formal: FormFormal | undefined;

    constructor(data?: IFormDocmentDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.no = data["no"];
            this.isOnline = data["isOnline"];
            this.version = data["version"];
            this.sequence = data["sequence"];
            this.formal = data["formal"] ? FormFormal.fromJS(data["formal"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FormDocmentDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new FormDocmentDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["no"] = this.no;
        data["isOnline"] = this.isOnline;
        data["version"] = this.version;
        data["sequence"] = this.sequence;
        data["formal"] = this.formal ? this.formal.toJSON() : <any>undefined;
        return data; 
    }

    clone(): FormDocmentDto_Update {
        const json = this.toJSON();
        let result = new FormDocmentDto_Update();
        result.init(json);
        return result;
    }
}

export interface IFormDocmentDto_Update {
    id: number | undefined;
    no: string | undefined;
    isOnline: boolean | undefined;
    version: string | undefined;
    sequence: number | undefined;
    formal: FormFormal | undefined;
}

export class FormFormalDto_Create implements IFormFormalDto_Create {
    id: number | undefined;
    no: string | undefined;
    name: string | undefined;
    sequence: number | undefined;
    frequence: FormFormalDto_CreateFrequence | undefined;

    constructor(data?: IFormFormalDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.no = data["no"];
            this.name = data["name"];
            this.sequence = data["sequence"];
            this.frequence = data["frequence"];
        }
    }

    static fromJS(data: any): FormFormalDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new FormFormalDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["no"] = this.no;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["frequence"] = this.frequence;
        return data; 
    }

    clone(): FormFormalDto_Create {
        const json = this.toJSON();
        let result = new FormFormalDto_Create();
        result.init(json);
        return result;
    }
}

export interface IFormFormalDto_Create {
    id: number | undefined;
    no: string | undefined;
    name: string | undefined;
    sequence: number | undefined;
    frequence: FormFormalDto_CreateFrequence | undefined;
}

export class FormFormalDto_WithRelation implements IFormFormalDto_WithRelation {
    formGroups: FormGroupDto[] | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    no: string | undefined;
    name: string | undefined;
    sequence: number | undefined;
    frequence: FormFormalDto_WithRelationFrequence | undefined;

    constructor(data?: IFormFormalDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["formGroups"] && data["formGroups"].constructor === Array) {
                this.formGroups = [] as any;
                for (let item of data["formGroups"])
                    this.formGroups.push(FormGroupDto.fromJS(item));
            }
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.no = data["no"];
            this.name = data["name"];
            this.sequence = data["sequence"];
            this.frequence = data["frequence"];
        }
    }

    static fromJS(data: any): FormFormalDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new FormFormalDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.formGroups && this.formGroups.constructor === Array) {
            data["formGroups"] = [];
            for (let item of this.formGroups)
                data["formGroups"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["no"] = this.no;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["frequence"] = this.frequence;
        return data; 
    }

    clone(): FormFormalDto_WithRelation {
        const json = this.toJSON();
        let result = new FormFormalDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IFormFormalDto_WithRelation {
    formGroups: FormGroupDto[] | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    no: string | undefined;
    name: string | undefined;
    sequence: number | undefined;
    frequence: FormFormalDto_WithRelationFrequence | undefined;
}

export class FormGroupDto implements IFormGroupDto {
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
    formFormalId: number | undefined;
    formItems: FormItem[] | undefined;

    constructor(data?: IFormGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.sequence = data["sequence"];
            this.formFormalId = data["formFormalId"];
            if (data["formItems"] && data["formItems"].constructor === Array) {
                this.formItems = [] as any;
                for (let item of data["formItems"])
                    this.formItems.push(FormItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["formFormalId"] = this.formFormalId;
        if (this.formItems && this.formItems.constructor === Array) {
            data["formItems"] = [];
            for (let item of this.formItems)
                data["formItems"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FormGroupDto {
        const json = this.toJSON();
        let result = new FormGroupDto();
        result.init(json);
        return result;
    }
}

export interface IFormGroupDto {
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
    formFormalId: number | undefined;
    formItems: FormItem[] | undefined;
}

export class FormFormalDto_Update implements IFormFormalDto_Update {
    id: number | undefined;
    no: string | undefined;
    name: string | undefined;
    sequence: number | undefined;
    frequence: FormFormalDto_UpdateFrequence | undefined;

    constructor(data?: IFormFormalDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.no = data["no"];
            this.name = data["name"];
            this.sequence = data["sequence"];
            this.frequence = data["frequence"];
        }
    }

    static fromJS(data: any): FormFormalDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new FormFormalDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["no"] = this.no;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["frequence"] = this.frequence;
        return data; 
    }

    clone(): FormFormalDto_Update {
        const json = this.toJSON();
        let result = new FormFormalDto_Update();
        result.init(json);
        return result;
    }
}

export interface IFormFormalDto_Update {
    id: number | undefined;
    no: string | undefined;
    name: string | undefined;
    sequence: number | undefined;
    frequence: FormFormalDto_UpdateFrequence | undefined;
}

export class FormFormalDto_LoadAllSearch implements IFormFormalDto_LoadAllSearch {
    keyword: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IFormFormalDto_LoadAllSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.keyword = data["keyword"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): FormFormalDto_LoadAllSearch {
        data = typeof data === 'object' ? data : {};
        let result = new FormFormalDto_LoadAllSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["keyword"] = this.keyword;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): FormFormalDto_LoadAllSearch {
        const json = this.toJSON();
        let result = new FormFormalDto_LoadAllSearch();
        result.init(json);
        return result;
    }
}

export interface IFormFormalDto_LoadAllSearch {
    keyword: string | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfFormFormalDto_WithRelation implements IPagedResultDtoOfFormFormalDto_WithRelation {
    totalCount: number | undefined;
    items: FormFormalDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfFormFormalDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(FormFormalDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFormFormalDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFormFormalDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfFormFormalDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfFormFormalDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfFormFormalDto_WithRelation {
    totalCount: number | undefined;
    items: FormFormalDto_WithRelation[] | undefined;
}

export class FormFormalDto_LoadAll implements IFormFormalDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IFormFormalDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): FormFormalDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new FormFormalDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): FormFormalDto_LoadAll {
        const json = this.toJSON();
        let result = new FormFormalDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IFormFormalDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class FormGroupDto_LoadAll implements IFormGroupDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IFormGroupDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): FormGroupDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new FormGroupDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): FormGroupDto_LoadAll {
        const json = this.toJSON();
        let result = new FormGroupDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IFormGroupDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfFormGroupDto_WithRelation implements IPagedResultDtoOfFormGroupDto_WithRelation {
    totalCount: number | undefined;
    items: FormGroupDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfFormGroupDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(FormGroupDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFormGroupDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFormGroupDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfFormGroupDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfFormGroupDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfFormGroupDto_WithRelation {
    totalCount: number | undefined;
    items: FormGroupDto_WithRelation[] | undefined;
}

export class FormGroupDto_WithRelation implements IFormGroupDto_WithRelation {
    formFormal: FormFormalDto | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
    formFormalId: number | undefined;
    formItems: FormItem[] | undefined;

    constructor(data?: IFormGroupDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.formFormal = data["formFormal"] ? FormFormalDto.fromJS(data["formFormal"]) : <any>undefined;
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.name = data["name"];
            this.sequence = data["sequence"];
            this.formFormalId = data["formFormalId"];
            if (data["formItems"] && data["formItems"].constructor === Array) {
                this.formItems = [] as any;
                for (let item of data["formItems"])
                    this.formItems.push(FormItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormGroupDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new FormGroupDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formFormal"] = this.formFormal ? this.formFormal.toJSON() : <any>undefined;
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["formFormalId"] = this.formFormalId;
        if (this.formItems && this.formItems.constructor === Array) {
            data["formItems"] = [];
            for (let item of this.formItems)
                data["formItems"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FormGroupDto_WithRelation {
        const json = this.toJSON();
        let result = new FormGroupDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IFormGroupDto_WithRelation {
    formFormal: FormFormalDto | undefined;
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
    formFormalId: number | undefined;
    formItems: FormItem[] | undefined;
}

export class FormFormalDto implements IFormFormalDto {
    id: number | undefined;
    no: string | undefined;
    name: string | undefined;
    sequence: number | undefined;
    frequence: FormFormalDtoFrequence | undefined;

    constructor(data?: IFormFormalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.no = data["no"];
            this.name = data["name"];
            this.sequence = data["sequence"];
            this.frequence = data["frequence"];
        }
    }

    static fromJS(data: any): FormFormalDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormFormalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["no"] = this.no;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["frequence"] = this.frequence;
        return data; 
    }

    clone(): FormFormalDto {
        const json = this.toJSON();
        let result = new FormFormalDto();
        result.init(json);
        return result;
    }
}

export interface IFormFormalDto {
    id: number | undefined;
    no: string | undefined;
    name: string | undefined;
    sequence: number | undefined;
    frequence: FormFormalDtoFrequence | undefined;
}

export class FormGroupDto_Create implements IFormGroupDto_Create {
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
    formFormalId: number | undefined;
    formItems: FormItem[] | undefined;

    constructor(data?: IFormGroupDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.sequence = data["sequence"];
            this.formFormalId = data["formFormalId"];
            if (data["formItems"] && data["formItems"].constructor === Array) {
                this.formItems = [] as any;
                for (let item of data["formItems"])
                    this.formItems.push(FormItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormGroupDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new FormGroupDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["formFormalId"] = this.formFormalId;
        if (this.formItems && this.formItems.constructor === Array) {
            data["formItems"] = [];
            for (let item of this.formItems)
                data["formItems"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FormGroupDto_Create {
        const json = this.toJSON();
        let result = new FormGroupDto_Create();
        result.init(json);
        return result;
    }
}

export interface IFormGroupDto_Create {
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
    formFormalId: number | undefined;
    formItems: FormItem[] | undefined;
}

export class FormGroupDto_Update implements IFormGroupDto_Update {
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
    formFormalId: number | undefined;
    formItems: FormItem[] | undefined;

    constructor(data?: IFormGroupDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.sequence = data["sequence"];
            this.formFormalId = data["formFormalId"];
            if (data["formItems"] && data["formItems"].constructor === Array) {
                this.formItems = [] as any;
                for (let item of data["formItems"])
                    this.formItems.push(FormItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormGroupDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new FormGroupDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sequence"] = this.sequence;
        data["formFormalId"] = this.formFormalId;
        if (this.formItems && this.formItems.constructor === Array) {
            data["formItems"] = [];
            for (let item of this.formItems)
                data["formItems"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FormGroupDto_Update {
        const json = this.toJSON();
        let result = new FormGroupDto_Update();
        result.init(json);
        return result;
    }
}

export interface IFormGroupDto_Update {
    id: number | undefined;
    name: string | undefined;
    sequence: number | undefined;
    formFormalId: number | undefined;
    formItems: FormItem[] | undefined;
}

export class RecordDocRecadminDto implements IRecordDocRecadminDto {
    name: string | undefined;
    no: string | undefined;
    version: string | undefined;
    recordId: number | undefined;
    docId: number | undefined;
    recordStatus: RecordDocRecadminDtoRecordStatus | undefined;
    submitDate: Date | undefined;

    constructor(data?: IRecordDocRecadminDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.name = data["name"];
            this.no = data["no"];
            this.version = data["version"];
            this.recordId = data["recordId"];
            this.docId = data["docId"];
            this.recordStatus = data["recordStatus"];
            this.submitDate = data["submitDate"] ? new Date(data["submitDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecordDocRecadminDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordDocRecadminDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["no"] = this.no;
        data["version"] = this.version;
        data["recordId"] = this.recordId;
        data["docId"] = this.docId;
        data["recordStatus"] = this.recordStatus;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        return data; 
    }

    clone(): RecordDocRecadminDto {
        const json = this.toJSON();
        let result = new RecordDocRecadminDto();
        result.init(json);
        return result;
    }
}

export interface IRecordDocRecadminDto {
    name: string | undefined;
    no: string | undefined;
    version: string | undefined;
    recordId: number | undefined;
    docId: number | undefined;
    recordStatus: RecordDocRecadminDtoRecordStatus | undefined;
    submitDate: Date | undefined;
}

export class RecordDocRecDto implements IRecordDocRecDto {
    no: string | undefined;
    version: string | undefined;
    recordId: number | undefined;
    docId: number | undefined;
    submitDate: Date | undefined;

    constructor(data?: IRecordDocRecDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.no = data["no"];
            this.version = data["version"];
            this.recordId = data["recordId"];
            this.docId = data["docId"];
            this.submitDate = data["submitDate"] ? new Date(data["submitDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecordDocRecDto {
        data = typeof data === 'object' ? data : {};
        let result = new RecordDocRecDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["no"] = this.no;
        data["version"] = this.version;
        data["recordId"] = this.recordId;
        data["docId"] = this.docId;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        return data; 
    }

    clone(): RecordDocRecDto {
        const json = this.toJSON();
        let result = new RecordDocRecDto();
        result.init(json);
        return result;
    }
}

export interface IRecordDocRecDto {
    no: string | undefined;
    version: string | undefined;
    recordId: number | undefined;
    docId: number | undefined;
    submitDate: Date | undefined;
}

export class FormRecordDto_LoadAllSearch implements IFormRecordDto_LoadAllSearch {
    recordStatus: FormRecordDto_LoadAllSearchRecordStatus | undefined;
    keyword: string | undefined;
    docId: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IFormRecordDto_LoadAllSearch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.recordStatus = data["recordStatus"];
            this.keyword = data["keyword"];
            this.docId = data["docId"];
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): FormRecordDto_LoadAllSearch {
        data = typeof data === 'object' ? data : {};
        let result = new FormRecordDto_LoadAllSearch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordStatus"] = this.recordStatus;
        data["keyword"] = this.keyword;
        data["docId"] = this.docId;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): FormRecordDto_LoadAllSearch {
        const json = this.toJSON();
        let result = new FormRecordDto_LoadAllSearch();
        result.init(json);
        return result;
    }
}

export interface IFormRecordDto_LoadAllSearch {
    recordStatus: FormRecordDto_LoadAllSearchRecordStatus | undefined;
    keyword: string | undefined;
    docId: number | undefined;
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class PagedResultDtoOfFormRecordDto_WithRelation implements IPagedResultDtoOfFormRecordDto_WithRelation {
    totalCount: number | undefined;
    items: FormRecordDto_WithRelation[] | undefined;

    constructor(data?: IPagedResultDtoOfFormRecordDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(FormRecordDto_WithRelation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfFormRecordDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfFormRecordDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data; 
    }

    clone(): PagedResultDtoOfFormRecordDto_WithRelation {
        const json = this.toJSON();
        let result = new PagedResultDtoOfFormRecordDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IPagedResultDtoOfFormRecordDto_WithRelation {
    totalCount: number | undefined;
    items: FormRecordDto_WithRelation[] | undefined;
}

export class FormRecordDto_WithRelation implements IFormRecordDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    recordStatus: FormRecordDto_WithRelationRecordStatus | undefined;
    submitDate: Date | undefined;
    docmentlId: number | undefined;
    recorder: string | undefined;
    recordData: RecordData[] | undefined;

    constructor(data?: IFormRecordDto_WithRelation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.fullAudited = data["fullAudited"] ? FullAuditedDto.fromJS(data["fullAudited"]) : <any>undefined;
            this.id = data["id"];
            this.recordStatus = data["recordStatus"];
            this.submitDate = data["submitDate"] ? new Date(data["submitDate"].toString()) : <any>undefined;
            this.docmentlId = data["docmentlId"];
            this.recorder = data["recorder"];
            if (data["recordData"] && data["recordData"].constructor === Array) {
                this.recordData = [] as any;
                for (let item of data["recordData"])
                    this.recordData.push(RecordData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormRecordDto_WithRelation {
        data = typeof data === 'object' ? data : {};
        let result = new FormRecordDto_WithRelation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["fullAudited"] = this.fullAudited ? this.fullAudited.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["recordStatus"] = this.recordStatus;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["docmentlId"] = this.docmentlId;
        data["recorder"] = this.recorder;
        if (this.recordData && this.recordData.constructor === Array) {
            data["recordData"] = [];
            for (let item of this.recordData)
                data["recordData"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FormRecordDto_WithRelation {
        const json = this.toJSON();
        let result = new FormRecordDto_WithRelation();
        result.init(json);
        return result;
    }
}

export interface IFormRecordDto_WithRelation {
    tenantId: number | undefined;
    fullAudited: FullAuditedDto | undefined;
    id: number | undefined;
    recordStatus: FormRecordDto_WithRelationRecordStatus | undefined;
    submitDate: Date | undefined;
    docmentlId: number | undefined;
    recorder: string | undefined;
    recordData: RecordData[] | undefined;
}

export class RecordData implements IRecordData {
    items: QuestItem[] | undefined;
    groupId: number | undefined;

    constructor(data?: IRecordData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items.push(QuestItem.fromJS(item));
            }
            this.groupId = data["groupId"];
        }
    }

    static fromJS(data: any): RecordData {
        data = typeof data === 'object' ? data : {};
        let result = new RecordData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["groupId"] = this.groupId;
        return data; 
    }

    clone(): RecordData {
        const json = this.toJSON();
        let result = new RecordData();
        result.init(json);
        return result;
    }
}

export interface IRecordData {
    items: QuestItem[] | undefined;
    groupId: number | undefined;
}

export class QuestItem implements IQuestItem {
    questNumber: number | undefined;
    answer: string | undefined;

    constructor(data?: IQuestItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.questNumber = data["questNumber"];
            this.answer = data["answer"];
        }
    }

    static fromJS(data: any): QuestItem {
        data = typeof data === 'object' ? data : {};
        let result = new QuestItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questNumber"] = this.questNumber;
        data["answer"] = this.answer;
        return data; 
    }

    clone(): QuestItem {
        const json = this.toJSON();
        let result = new QuestItem();
        result.init(json);
        return result;
    }
}

export interface IQuestItem {
    questNumber: number | undefined;
    answer: string | undefined;
}

export class FormRecordDto implements IFormRecordDto {
    id: number | undefined;
    recordStatus: FormRecordDtoRecordStatus | undefined;
    submitDate: Date | undefined;
    docmentlId: number | undefined;
    recorder: string | undefined;
    recordData: RecordData[] | undefined;

    constructor(data?: IFormRecordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.recordStatus = data["recordStatus"];
            this.submitDate = data["submitDate"] ? new Date(data["submitDate"].toString()) : <any>undefined;
            this.docmentlId = data["docmentlId"];
            this.recorder = data["recorder"];
            if (data["recordData"] && data["recordData"].constructor === Array) {
                this.recordData = [] as any;
                for (let item of data["recordData"])
                    this.recordData.push(RecordData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormRecordDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormRecordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recordStatus"] = this.recordStatus;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["docmentlId"] = this.docmentlId;
        data["recorder"] = this.recorder;
        if (this.recordData && this.recordData.constructor === Array) {
            data["recordData"] = [];
            for (let item of this.recordData)
                data["recordData"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FormRecordDto {
        const json = this.toJSON();
        let result = new FormRecordDto();
        result.init(json);
        return result;
    }
}

export interface IFormRecordDto {
    id: number | undefined;
    recordStatus: FormRecordDtoRecordStatus | undefined;
    submitDate: Date | undefined;
    docmentlId: number | undefined;
    recorder: string | undefined;
    recordData: RecordData[] | undefined;
}

export class FormRecordDto_LoadAll implements IFormRecordDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;

    constructor(data?: IFormRecordDto_LoadAll) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sorting = data["sorting"];
            this.skipCount = data["skipCount"];
            this.maxResultCount = data["maxResultCount"];
        }
    }

    static fromJS(data: any): FormRecordDto_LoadAll {
        data = typeof data === 'object' ? data : {};
        let result = new FormRecordDto_LoadAll();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data; 
    }

    clone(): FormRecordDto_LoadAll {
        const json = this.toJSON();
        let result = new FormRecordDto_LoadAll();
        result.init(json);
        return result;
    }
}

export interface IFormRecordDto_LoadAll {
    sorting: string | undefined;
    skipCount: number | undefined;
    maxResultCount: number | undefined;
}

export class FormRecordDto_Create implements IFormRecordDto_Create {
    id: number | undefined;
    recordStatus: FormRecordDto_CreateRecordStatus | undefined;
    submitDate: Date | undefined;
    docmentlId: number | undefined;
    recorder: string | undefined;
    recordData: RecordData[] | undefined;

    constructor(data?: IFormRecordDto_Create) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.recordStatus = data["recordStatus"];
            this.submitDate = data["submitDate"] ? new Date(data["submitDate"].toString()) : <any>undefined;
            this.docmentlId = data["docmentlId"];
            this.recorder = data["recorder"];
            if (data["recordData"] && data["recordData"].constructor === Array) {
                this.recordData = [] as any;
                for (let item of data["recordData"])
                    this.recordData.push(RecordData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormRecordDto_Create {
        data = typeof data === 'object' ? data : {};
        let result = new FormRecordDto_Create();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recordStatus"] = this.recordStatus;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["docmentlId"] = this.docmentlId;
        data["recorder"] = this.recorder;
        if (this.recordData && this.recordData.constructor === Array) {
            data["recordData"] = [];
            for (let item of this.recordData)
                data["recordData"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FormRecordDto_Create {
        const json = this.toJSON();
        let result = new FormRecordDto_Create();
        result.init(json);
        return result;
    }
}

export interface IFormRecordDto_Create {
    id: number | undefined;
    recordStatus: FormRecordDto_CreateRecordStatus | undefined;
    submitDate: Date | undefined;
    docmentlId: number | undefined;
    recorder: string | undefined;
    recordData: RecordData[] | undefined;
}

export class FormRecordDto_Update implements IFormRecordDto_Update {
    id: number | undefined;
    recordStatus: FormRecordDto_UpdateRecordStatus | undefined;
    submitDate: Date | undefined;
    docmentlId: number | undefined;
    recorder: string | undefined;
    recordData: RecordData[] | undefined;

    constructor(data?: IFormRecordDto_Update) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"];
            this.recordStatus = data["recordStatus"];
            this.submitDate = data["submitDate"] ? new Date(data["submitDate"].toString()) : <any>undefined;
            this.docmentlId = data["docmentlId"];
            this.recorder = data["recorder"];
            if (data["recordData"] && data["recordData"].constructor === Array) {
                this.recordData = [] as any;
                for (let item of data["recordData"])
                    this.recordData.push(RecordData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormRecordDto_Update {
        data = typeof data === 'object' ? data : {};
        let result = new FormRecordDto_Update();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recordStatus"] = this.recordStatus;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["docmentlId"] = this.docmentlId;
        data["recorder"] = this.recorder;
        if (this.recordData && this.recordData.constructor === Array) {
            data["recordData"] = [];
            for (let item of this.recordData)
                data["recordData"].push(item.toJSON());
        }
        return data; 
    }

    clone(): FormRecordDto_Update {
        const json = this.toJSON();
        let result = new FormRecordDto_Update();
        result.init(json);
        return result;
    }
}

export interface IFormRecordDto_Update {
    id: number | undefined;
    recordStatus: FormRecordDto_UpdateRecordStatus | undefined;
    submitDate: Date | undefined;
    docmentlId: number | undefined;
    recorder: string | undefined;
    recordData: RecordData[] | undefined;
}

export enum FormFormalFrequence {
    _0 = 0, 
    _1 = 1, 
}

export enum FormItemType {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
    _3 = 3, 
    _4 = 4, 
    _5 = 5, 
    _6 = 6, 
}

export enum FormDocmentDto_LoadAllSearchFrequence {
    _0 = 0, 
    _1 = 1, 
}

export enum FormFormalDto_CreateFrequence {
    _0 = 0, 
    _1 = 1, 
}

export enum FormFormalDto_WithRelationFrequence {
    _0 = 0, 
    _1 = 1, 
}

export enum FormFormalDto_UpdateFrequence {
    _0 = 0, 
    _1 = 1, 
}

export enum FormFormalDtoFrequence {
    _0 = 0, 
    _1 = 1, 
}

export enum RecordDocRecadminDtoRecordStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum FormRecordDto_LoadAllSearchRecordStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum FormRecordDto_WithRelationRecordStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum FormRecordDtoRecordStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum FormRecordDto_CreateRecordStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export enum FormRecordDto_UpdateRecordStatus {
    _0 = 0, 
    _1 = 1, 
    _2 = 2, 
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}